<template>
    <div>
        <div class="material-page" v-if="has_no_audit_material">
            <div class="material-page-content">
                <span>有素材待审核快去看看吧</span>
                <el-button type="primary" size="mini" style="margin-left: 20px;"
                v-matomo="{behaviorCategory: '素材工单(工单管理)', event: '点击',  name: '顶部提示(立即审核)' }"
                @click="handleClick('2')">立即审核</el-button>
            </div>
        </div>
        <div class="material-page" v-if="has_rejected_material">
            <div class="material-page-content">
                <span>有工单被驳回快去看看吧</span>
                <el-button type="primary" size="mini" style="margin-left: 20px;"
                v-matomo="{behaviorCategory: '素材工单(工单管理)', event: '点击',  name: '顶部提示(立即查看驳回工单)' }"
                @click="handleClick('3')">立即查看</el-button>
            </div>
        </div>
    </div>

</template>
<script>
import API from "@/api/workOrder/material.js"
export default {
    data() {
        return {
            msg: '',
            has_no_audit_material: false,
            has_rejected_material: false,
            clearID: null,
            lock: false,
            timer: 0
        }
    },
    mounted() {
        this.fetchMsg()
        // this.clearID = setInterval(()=>{
        //     this.fetchMsg()
        // }, 1000 * 5)
    },
    methods: {
        fetchMsg() {
            API.getWorkOrderMsg().then(res=>{
                this.lock = false
                this.has_no_audit_material = res.data.has_no_audit_material
                this.has_rejected_material = res.data.has_rejected_material
            })
        },
        handleClick(type) {
            // if(type == '2') {
            //     this.has_no_audit_material = false
            // }else if(type == '3') {
            //     this.has_rejected_material = false
            // }
            this.$emit('msg-click', type)
        }
    },
    beforeDestroy() {
        if (this.clearID) {
            for (let i = 0; i < 10; i++) {
                clearInterval(this.clearID);
                this.clearID = null;
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.material-page {
    background: #ffffff;
    padding: 10px 10px;
    border-radius: 4px;
    margin-bottom: 10px;
}
</style>
